// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rowLoader_loader__rtQ7U {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  height: 2px;\n  z-index: 2;\n}\n.rowLoader_loader__rtQ7U div {\n  height: inherit;\n  background-color: var(--primary);\n  animation: rowLoader_loader__rtQ7U 2s infinite alternate linear;\n}\n@keyframes rowLoader_loader__rtQ7U {\n  0% {\n    width: 0px;\n    transform: translateX(0);\n  }\n  50% {\n    width: 200px;\n    transform: translateX(calc(100vw / 2));\n  }\n  100% {\n    width: 0px;\n    transform: translateX(100vw);\n  }\n}", ""]);
// Exports
exports.locals = {
	"loader": "rowLoader_loader__rtQ7U"
};
module.exports = exports;
